import { faExclamation } from '@fortawesome/pro-solid-svg-icons';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { NotificationManager } from '@shared/app/scripts/services/notification-manager';
import { Language } from '@shared/app/scripts/services/language';

/**
 * Component reponible for www#/profile/:
 */
angular.module('gateApp').component('profile', {
  template: require('./profile.html').default,
  controller: function (
    $location: ng.ILocationService,
    $q: ng.IQService,
    $translate: ng.translate.ITranslateService,
    $uibModal: ng.ui.bootstrap.IModalService,
    currentSession: CurrentSession,
    language: Language,
    moment,
    notificationManager: NotificationManager,
    user,
  ) {
    // TODO cover by unit tests
    const $ctrl = this;

    $ctrl.$onInit = () => {
      if (!currentSession.isLogged) {
        $location.url('/landing-page');
      }

      $ctrl.email = currentSession.email;

      $ctrl.currentUser = {
        language: currentSession.language,
        fullname: currentSession.fullname,
        username: currentSession.username,
        tz: currentSession.tz,
      };

      $ctrl.newUsername = currentSession.username;
      $ctrl.userId = currentSession.userId;

      //TODO CORE-191 - Generic editable input directive
      //TODO better way of documenting a structure like this
      /**
       * Simple encapsulated module that controls the editing and saving of emails
       */
      $ctrl.editEmail = {
        editable: false,
        oldEmail: currentSession.email,
        confirmPassword: '',
        cancel: function () {
          $ctrl.editEmail.editable = false;
          $ctrl.editEmail.confirmPassword = '';
          $ctrl.email = this.oldEmail;
        },
        show: function () {
          $ctrl.editPassword.cancel();
          $ctrl.editEmail.editable = true;
          $ctrl.editEmail.confirmPassword = '';
          $ctrl.email = this.oldEmail;
        },
        save: function (password, email) {
          if (!email) {
            notificationManager.sendError(
              $translate.instant('gate.validation.email_cannot_be_empty'),
            );
            return $q.when();
          }
          if (!password) {
            notificationManager.sendError(
              $translate.instant('gate.validation.password_cannot_be_empty'),
            );
            return $q.when();
          }

          const promise = user.changeOwnEmail(password, email);

          promise.then((message) => {
            notificationManager.sendSuccess(
              message,
              'profile-edit-email-success',
            );
            $ctrl.editEmail.editable = false;
            $ctrl.editEmail.oldEmail = email;
          }); //TODO consider showing notification in case of failed save

          return promise;
        },
      };
    };

    $ctrl.timeZones = moment.tz.names();

    //TODO CORE-191 - Generic editable input directive
    //TODO better way of documenting a structure like this
    /**
     * Simple encapsulated module that controls the editing and saving of password
     */
    $ctrl.editPassword = {
      editable: false,
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
      cancel: function () {
        $ctrl.editPassword.editable = false;
        $ctrl.editPassword.currentPassword = '';
        $ctrl.editPassword.newPassword = '';
        $ctrl.editPassword.newPasswordConfirmation = '';
      },
      show: function () {
        $ctrl.editEmail.cancel();
        $ctrl.editPassword.editable = true;
        $ctrl.editPassword.currentPassword = '';
        $ctrl.editPassword.newPassword = '';
        $ctrl.editPassword.newPasswordConfirmation = '';
      },
      save: function (currentPassword, newPassword, newPasswordConfirmation) {
        if (!currentPassword || !newPassword || !newPasswordConfirmation) {
          notificationManager.sendError(
            $translate.instant('gate.validation.password_cannot_be_empty'),
          );
          return $q.when();
        }

        //TODO change core to instead of returning a true to just return the message of the server
        const promise = user.changePassword(
          currentPassword,
          newPassword,
          newPasswordConfirmation,
        );

        promise.then(() => {
          notificationManager.sendSuccess(
            $translate.instant('gate.password_changed'),
            'profile-edit-password-success',
          );
          $ctrl.editPassword.currentPassword = '';
          $ctrl.editPassword.editable = false;
        }); //TODO consider showing notification in case of failed save

        return promise;
      },
    };

    $ctrl.submit = (currentUser) => {
      const savingNotification = notificationManager.sendInfo(
        $translate.instant('gate.saving'),
        'profile-saving-user',
      );

      // Update the language key in case it has been adjusted since loading
      currentUser.language = language.current;

      const savePromise = user.updateUserProfile(currentUser);

      savePromise
        .then(
          (message) => {
            notificationManager.sendSuccess(
              message,
              'profile-user-save-success',
            );
            // update user values
          },
          (error) => {
            notificationManager.sendError(error, 'profile-save-user-error');
          },
        )
        .finally(() => {
          savingNotification.remove();
        });

      return savePromise;
    };

    let openWarningModal = () => {
      let modal = $uibModal.open({
        template: require('./warning-modal.html').default,
        windowClass: 'sw-modal sw-warning-modal',
        controller: function ($uibModalInstance) {
          const $ctrl = this;

          $ctrl.close = (answer) => $uibModalInstance.close(answer);

          $ctrl.faExclamation = faExclamation;
        },
        controllerAs: '$ctrl',
      });
      return modal.result;
    };

    $ctrl.changeUsername = (userId, username) => {
      return openWarningModal().then((answer) => {
        // accept button on the modal is clicked
        if (answer) {
          const savingNotification = notificationManager.sendInfo(
            $translate.instant('gate.saving'),
            'user-saving',
            0, // 0 means infinite life time until manually removed
          );

          return user
            .changeUsername(userId, username)
            .then(() => {
              notificationManager.sendSuccess($translate.instant('gate.saved'));
              $ctrl.currentUser.username = username;

              $ctrl.newUsername = $ctrl.currentUser.username;
            })
            .catch((error) => {
              notificationManager.sendError(
                $translate.instant('gate.server_error'),
                'user-saving-error',
                undefined,
                new Error(error),
              );
              return $q.reject($translate.instant('gate.server_error'));
            })
            .finally(() => {
              savingNotification.remove();
            });
        } else {
          $ctrl.newUsername = $ctrl.currentUser.username;
          return $q.resolve();
        }
      });
    };
  },
});
